export function msecToMinute(msec: number): number {
  return msec / 60000;
}

export function msecToHour(msec: number): number {
  return msec / 3600000;
}

export function secToMsec(seconds: number): number {
  return seconds * 1000;
}

export function secToHour(seconds: number): number {
  return seconds / 3600;
}

export function hourToSec(hours: number): number {
  return hours * 3600;
}

export function dayToMsec(days: number): number {
  return days * 86400000;
}

export function round(time: number, granularityMsec: number): number;
export function round(time: Date, granularityMsec: number): Date;
export function round(time: number | Date, granularityMsec: number) {
  if (typeof time === 'number') {
    return Math.floor(time / granularityMsec) * granularityMsec;
  } else {
    let result = new Date();
    result.setTime(round(time.getTime(), granularityMsec));
    return result;
  }
}

export function unixMsec(): number {
  return new Date().getTime();
}

export function strFromMinutes(minutes: number): string {
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  const hoursStr = hours.toString().padStart(2, '0');
  const minsStr = mins.toString().padStart(2, '0');
  return `${hoursStr}:${minsStr}`;
}

export function minutesFromStr(timeStr: string): number {
  if (!timeStr) {
    throw new Error('Invalid time format');
  }
  const [hours, minutes] = timeStr.split(':');
  const parsedHours = parseInt(hours);
  const parsedMinutes = parseInt(minutes);

  if (isNaN(parsedHours) || isNaN(parsedMinutes)) {
    throw new Error('Invalid time format');
  }

  return parsedHours * 60 + parsedMinutes;
}

export function dateFromUnixMsec(unixMsec: number): Date {
  let dt = new Date();
  dt.setTime(unixMsec);
  return dt;
}

export function dateFromStr(dateStr: string): Date {
  return new Date(dateStr.replace(" ", "T"));
}

export function dateFromStrAsUtc(dateStr: string): Date {
  return dateFromStr(dateStr + "Z");
}

function formatInternal(symbol: { [key: string]: number }, fmt: string): string {
  return fmt.replace(/(Y+|M+|D+|H+|m+|s+|S+)/g, (s: string) => {
    if (s.charAt(0) === 'Y') {
      return symbol.Y.toString().slice(-s.length);
    } else if (s.charAt(0) === 'S') {
      let msecStr = symbol.S.toString();
      while (msecStr.length < 3) {
        msecStr = '0' + msecStr;
      }
      return msecStr.padEnd(s.length, '0').substr(0, s.length);
    } else {
      return ((s.length > 1 ? '0' : '') + symbol[s.slice(-1)]).slice(-2);
    }
  });
};

export function format(date: Date, fmt: string): string {
  return formatInternal({
    Y: date.getFullYear(),
    M: date.getMonth() + 1,
    D: date.getDate(),
    H: date.getHours(),
    m: date.getMinutes(),
    s: date.getSeconds(),
    S: date.getMilliseconds(),
  }, fmt);
};

export function formatUtc(date: Date, fmt: string): string {
  return formatInternal({
    Y: date.getUTCFullYear(),
    M: date.getUTCMonth() + 1,
    D: date.getUTCDate(),
    H: date.getUTCHours(),
    m: date.getUTCMinutes(),
    s: date.getUTCSeconds(),
    S: date.getUTCMilliseconds(),
  }, fmt);
};

export function toHtmlDatetimeLocal(date: Date): string;
export function toHtmlDatetimeLocal(dateStr: string): string;
export function toHtmlDatetimeLocal(date: Date | string): string {
  let dateObj: Date;
  if (typeof date === 'string') {
    dateObj = dateFromStr(date);
  } else {
    dateObj = date;
  }
  return format(dateObj, 'YYYY-MM-DDTHH:mm');
}
export function utcToHtmlDatetimeLocal(dateStr: string): string {
  return format(dateFromStrAsUtc(dateStr), 'YYYY-MM-DDTHH:mm');
}

export function timestampFromHours(h: number, m: number, s: number, ms: number): Date {
  const d = dateFromUnixMsec(0)
  d.setHours(h, m, s, ms);
  return d;
}
export function timestamp(unixMsec: number): number;
export function timestamp(date: Date): Date;
export function timestamp(date: number | Date) {
  if (typeof date === 'number') {
    return date % 86400000;
  } else {
    let dt = dateFromUnixMsec(0);
    dt.setHours(
      date.getHours(),
      date.getMinutes(),
      date.getSeconds(),
      date.getMilliseconds()
    );
    return dt;
  }
}

export function min(a: Date, b: Date): Date {
  return a.getTime() < b.getTime() ? a : b;
}

export function max(a: Date, b: Date): Date {
  return a.getTime() > b.getTime() ? a : b;
}

export function isSameDate(a: Date, b: Date): boolean {
  return (
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate()
  );
}

export function subtractDaysFromDate(dateString: string, days: number): string {
  const [year, month, day] = dateString.split('-').map(Number);
  const date = new Date(year, month - 1, day);
  date.setDate(date.getDate() - days);
  const resultYear = date.getFullYear();
  const resultMonth = String(date.getMonth() + 1).padStart(2, '0');
  const resultDay = String(date.getDate()).padStart(2, '0');
  return `${resultYear}-${resultMonth}-${resultDay}`;
}